import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import FacilityBarGraph from './FacilityBarGraph'
import FacilityPieChart from './FacilityPieChart'

function GraphPairForFacilities({ barGraphData, pieChartData, groupName, facilities, year, type, unit }) {
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'bar-graph'}>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                <FacilityBarGraph data={barGraphData} facilities={facilities} group={groupName} type={type} year={year} unit={unit} />
            </Grid>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                {groupName !== 'Twee Jonge Gezellen' && !(groupName === "Reyneke Wines" && type === "Dry Ice Purchased") &&
                    <FacilityPieChart data={pieChartData} group={groupName} type={type} year={year} unit={unit} />
                }
            </Grid>
        </NoGraphData>
    )
}

export default GraphPairForFacilities;